import axios from 'axios'
import axiosInstance from '../axiosInstance'
import { Url,LANGUAGE,ADDRESS_API } from './constantUrl'
import * as types from './types'
import { errorHandler } from './error/errorHandler.action'
import getHeadersformdata from './getHeaderFormdata'
import getHeaders from './getHeaders'
import { HTTP_STATUS } from '../constants/httpstatus/HttpsStatus'
import { HTTP_METHOD } from '../constants/httpMethod/HttpMethod'
import { sprintf } from 'sprintf-js';
import { NotificationManager } from 'react-notifications'
import { decode } from 'base-64'
import Cookies from 'js-cookie'


// Add New Partner
export const addPartnerAction = (params = {}) => dispatch => {
    const API_URL = localStorage.getItem('countryBackendUrl')
    const url = API_URL + Url.ADD_PARTNER
    let options = Object.assign({ method: 'POST' }, params ? { data: params } : null)
    options.headers = getHeadersformdata()
    options.url = url
    return axiosInstance(options).then(resp => {
      if (resp.status === 200 || resp.status === 201) {
        dispatch({ type: types.POST_ADD_PARTNER, payload: resp })
        return resp
      } else { return null }
    }).catch(error => {
      if (error?.response?.status === 400) {
          const errorMessage = error.response.data;
          if(errorMessage?.role_ids){
            NotificationManager.error(errorMessage?.role_ids);
          }else if(errorMessage?.mobile_code){
            NotificationManager.error(errorMessage?.mobile_code);
          }else if(errorMessage?.mobile_number){
            NotificationManager.error(errorMessage?.mobile_number);
          }else if(errorMessage?.email){
            NotificationManager.error(errorMessage?.email);
          }else if(errorMessage?.DOB){
            NotificationManager.error(errorMessage?.DOB);
          }else{
            errorHandler(error)
          }
        return error
      }
    })
  }

// Add Security Password
export const securityAction = (params = {},id) => dispatch => {
  const API_URL = localStorage.getItem('countryBackendUrl')
  const url = API_URL + Url.SET_PASSWORD+"/"+id
  let options = Object.assign({ method: 'POST' }, params ? { data: params } : null)
  options.headers = getHeadersformdata()
  options.url = url
  return axiosInstance(options).then(resp => {
    if (resp.status === 200 || resp.status === 201) {
      dispatch({ type: types.POST_SET_PASSWORD, payload: resp })
      return resp
    } else { return null }
  }).catch(error => {
    if (error?.response?.status === 500) {
      const errorMessage = error.response.data;
      if(errorMessage?.message){
         NotificationManager.error(errorMessage?.message);
      }else{
         errorHandler(error)
      }
     return error
    }
  })
}

  // CREATE BUSINESS CONTACT
export const createBusninessContactAction = (params = {}) => dispatch => {
    const API_URL = localStorage.getItem('countryBackendUrl')
    const url = API_URL + Url.CREATE_BUSINESS_CONTACT
    let options = Object.assign({ method: 'POST' }, params ? { data: params } : null)
    options.headers = getHeaders()
    options.url = url
    return axiosInstance(options).then(resp => {
      if (resp.status === 200 || resp.status === 201) {
        dispatch({ type: types.POST_CREATE_BUSINESS_CONTACT, payload: resp })
        return resp
      } else { return null }
    }).catch(error => {
      errorHandler(error)
    })
  }

    // UPLOAD BUSINESS CONTACT FILE
export const uploadBusninessContactFileAction = (params = {}) => dispatch => {
  const API_URL = localStorage.getItem('countryBackendUrl')
  const url = API_URL + Url.UPLOAD_BUSINESS_CONTACT_FILE
  let options = Object.assign({ method: 'POST' }, params ? { data: params } : null)
  options.headers = getHeadersformdata()
  options.url = url
  return axiosInstance(options).then(resp => {
    if (resp.status === 200 || resp.status === 201) {
      dispatch({ type: types.POST_UPLOAD_BUSINESS_CONTACT_FILE, payload: resp })
      return resp
    } else { return null }
  }).catch(error => {
    errorHandler(error)
  })
}

    // DELETE BUSINESS CONTACT STORE PHOTO
    export const deleteStorePhotoAction = (id) => dispatch => {
      const API_URL = localStorage.getItem('countryBackendUrl')
      const url = API_URL + Url.DELETE_STORE_PHOTO+"/"+id
      let options = Object.assign({ method: 'POST' })
      options.headers = getHeaders()
      options.url = url
      return axiosInstance(options).then(resp => {
        if (resp.status === 200 || resp.status === 201) {
          dispatch({ type: types.POST_DELETE_STORE_PHOTO, payload: resp })
          return resp
        } else { return null }
      }).catch(error => {
        errorHandler(error)
      })
    }

    // Create Questionnaire
export const createQuestionnaireAction = (params = {}) => dispatch => {
  const API_URL = localStorage.getItem('countryBackendUrl')
  const url = API_URL + Url.CREATE_QUESTIONNAIRE
  let options = Object.assign({ method: 'POST' }, params ? { data: params } : null)
  options.headers = getHeaders()
  options.url = url
  return axiosInstance(options).then(resp => {
    if (resp.status === 200 || resp.status === 201) {
      dispatch({ type: types.POST_CREATE_QUESTIONNAIRE_DETAIL, payload: resp })
      return resp
    } else { return null }
  }).catch(error => {
    errorHandler(error)
  })
}

// Genrate token post API For Gps Address and Postal code

export const adressTokenAction = () => dispatch => {
  const API_URL = localStorage.getItem('countryBackendUrl')
  const url = API_URL + Url.LAT_LONG_AUTH
  let options = Object.assign({ method: HTTP_METHOD.GET })
  options.headers = getHeaders()
  options.url = url;
  return axiosInstance(options).then(resp => {
    if (resp?.status === HTTP_STATUS.SUCCESS) {
      dispatch({ type: types.GET_ADDRESS_TOKEN, payload: resp })
      return resp
    } else { return null }
  }).catch(error => {
    errorHandler(error)
  })
}

// FOR revert after lag long api issues fix on uat 

export const tvsLatLongAuthTokenAPI = () => dispatch => {
  const url = sprintf(ADDRESS_API.LAT_LONG_AUTH_TOKEN_ENDPOINT, ADDRESS_API.LAT_LONG_API_GRANT_TYPE, ADDRESS_API.LAT_LONG_API_CLIENT_ID, ADDRESS_API.LAT_LONG_API_CLIENT_SECRET);
  let options = Object.assign({ method: HTTP_METHOD.POST })
  options.url = ADDRESS_API.BASE_URL + url;
  return axiosInstance(options).then(resp => {
    if (resp.status === HTTP_STATUS.SUCCESS) {
      dispatch({ type: types.POST_LAT_LONG_AUTH_RESPONSE, payload: resp })
      return resp
    } else { return null }
  }).catch(error => {
    errorHandler(error)
  })
}

// GET API Searched Address

export const searchdetailAction = (access_token, value, Country_name) => dispatch => {
  const countryCode = localStorage.getItem("countryLatLongCode")
  const url=sprintf(ADDRESS_API.SEARCH_LOCATION, value, access_token, countryCode, LANGUAGE)
  let options = Object.assign({ method: HTTP_METHOD.GET })
  options.url = ADDRESS_API.BASE_URL + url;
  return axiosInstance(options).then(resp => {
    if (resp.status === HTTP_STATUS.SUCCESS) {
      dispatch({ type: types.GET_ADDRESS_SUGGESTION, payload: resp })
      return resp
    } else { return null }
  })
    .catch(error => {
      errorHandler(error)
    })
}

// GET API FOR ADDRESS Detail

export const addressdetailAction = (latitude, longitude, access_token, Country_name) => dispatch => {
  const countryCode = localStorage.getItem("countryLatLongCode")
  const url = sprintf(ADDRESS_API.DETAILED_LOCATION, latitude, longitude, access_token, countryCode, LANGUAGE)
  let options = Object.assign({ method: HTTP_METHOD.GET })
  options.url = ADDRESS_API.BASE_URL + url;
  return axiosInstance(options).then(resp => {
    if (resp.status === HTTP_STATUS.SUCCESS) {
      dispatch({ type: types.GET_ADDRESS_DETAILED, payload: resp })
      return resp
    } else { return null }
  })
    .catch(error => {
      errorHandler(error)
    })
}